import React from "react";
import { shallowEqual } from "react-redux";
import * as Styles from "./UscCashPrice.styles";
import { useUscSelector } from "../../../../redux/store";
import DisclaimerIconWrapper from "../DisclaimerIconWrapper";
import { getTotalPriceSelector } from "../../../../utils/priceUtils";
import { formatUscCashPrice, getUscCashPriceFromVehicle } from "../../../../../shared-logic/utils/uscPriceUtils";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import { UscDisclaimerType } from "../../../../../shared-logic/types/UscCommonTypes";
import UscCashComponent from "./UscCashComponent";

type PropsType = {
    showRetailPrice?: boolean;
    showDiscountPrice?: boolean;
    hideDisclaimerIcons?: boolean;
};

const UscCashPrice = (props: PropsType): JSX.Element | null => {
    const { showRetailPrice = false, showDiscountPrice, hideDisclaimerIcons } = props;
    const { cashPrice } = useUscSelector(getTotalPriceSelector(), shallowEqual);
    const retailPrice = useUscSelector((state) => getUscCashPriceFromVehicle(state.vehicle.result), shallowEqual);
    const commonSettings = useUscSelector((state) => state.commonSettings);

    const [exVatLabel, inclVatLabel, genericCashLabel] = useCommonLabel([
        "uscExclVatCashPriceFormat",
        "uscInclVatCashPriceFormat",
        "uscCashPriceFormat",
    ]);

    const shownPrice = showRetailPrice ? retailPrice : cashPrice;
    const formattedCashPrice = formatUscCashPrice(
        commonSettings,
        shownPrice,
        exVatLabel,
        inclVatLabel,
        genericCashLabel,
    );

    const renderDiscountPrice = showDiscountPrice && formattedCashPrice.isPromotion;

    return (
        <>
            {renderDiscountPrice && (
                <Styles.CashDiscount>
                    {/* Only show the primary currency price when rendering a discount */}
                    <UscCashComponent formattedCashPrice={formattedCashPrice} showSecondaryPrice={false} />
                </Styles.CashDiscount>
            )}

            <Styles.PriceWrapper>
                <Styles.Cash>
                    <UscCashComponent formattedCashPrice={formattedCashPrice} showSecondaryPrice />
                </Styles.Cash>

                {!showRetailPrice && !hideDisclaimerIcons && (
                    <>
                        <DisclaimerIconWrapper type={UscDisclaimerType.Promotion} />
                        <DisclaimerIconWrapper type={UscDisclaimerType.Cash} />
                    </>
                )}
            </Styles.PriceWrapper>
        </>
    );
};

export default UscCashPrice;
